import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AccountRouteChecker from '../../AccountRouteChecker/AccountRouteChecker';
import { CreateHPoolRoutesLazy } from '../../RoutesWrapper';
import { _championVerificationUrl } from '../../Header/CreatePoolButton/CreatePoolButton';
import { delayedAction } from '../../../services/utilsService';

function IsChampionChecker({ isChampionVerified, champion }) {
  const { gettingChampionData: loading, gettingChampionProfileDataError: error } = champion || {};
  const notVerifiedChamp = !isChampionVerified;
  const validations = [
    {
      condition: notVerifiedChamp,
      msg: 'errors.not_verfied_user',
      onError: () => delayedAction(2000, () => window.open(_championVerificationUrl, '_blank')),
    },
  ];
  const foundError = useMemo(() => validations.find((validation) => validation.condition), [notVerifiedChamp]) || {};
  return (
    <>
      <AccountRouteChecker
        authDep={isChampionVerified}
        loading={loading}
        redirectionError={error || foundError.msg}
        onError={foundError?.onError}
        path="/create-pool"
        component={CreateHPoolRoutesLazy}
        requireLogin
        requireVerifiedChampion
      />
    </>
  );
}

IsChampionChecker.propTypes = {
  champion: PropTypes.object.isRequired,
  isChampionVerified: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ champion }) => ({
  isChampionVerified: champion.championData?.is_verified_champion === 'VERIFIED',
  championHasOwnPool: champion.championHasOwnPool,
  champion,
});

export default connect(mapStateToProps)(IsChampionChecker);
